<template>
  <div>
    <va-modal
      class="modal"
      v-model="showDevis"
      okText="Modifier le devis"
      cancelText="Fermer"
      max-width="100%"
      v-on:ok="openEdit"
      v-on:cancel="closeModal"
      :hideDefaultActions="true"
      disabled
      :title="title"
    >
      <div>
        <div class="forcewidth">
          <div class="row row-inside">
            <div class="flex md5">
              <div class="row row-inside">
                <div class="flex md12">
                  <div class="info-box">
                    <div class="info-box-title">Annonceur</div>
                    <div class="info-box-content">{{ devis.nom }}</div>
                  </div>
                </div>
              </div>
              <div class="row row-inside">
                <div class="flex md6">
                  <div class="info-box">
                    <div class="info-box-title">
                      Adresse principale du devis
                    </div>
                    <div class="info-box-content">{{ contact_devis }}</div>
                  </div>
                </div>
                <div class="flex md6">
                  <div class="info-box">
                    <div class="info-box-title">Adresse de facturation</div>
                    <div class="info-box-content">{{ contact_facture }}</div>
                  </div>
                </div>
              </div>
              <div class="row row-inside mt-3">
                <div class="flex md2">Attribution:</div>
                <div class="flex md4">
                  {{
                    devis.user_attribution
                      ? devis.user_attribution
                      : "Non attribué"
                  }}
                </div>
                <div class="flex md2">Facturation TVA:</div>
                <div class="flex md2">
                  {{ devis.tva_na ? "TVA non facturée" : "TVA Facturée" }}
                </div>
              </div>
              <div class="flex md12">
                <va-button
                  class="fullwidth"
                  :color="devis.isprospection ? 'warning' : 'success'"
                  >{{
                    devis.isprospection ? "Prospection" : "Commercial"
                  }}</va-button
                >
              </div>
            </div>
            <div class="flex md5">
              <div class="row row-inside">
                <div class="flex md12 offset--md1">
                  <div class="row row-inside">
                    <div class="flex md4">
                      Engagement sur {{ decomptesNumeros }} numéros
                    </div>
                    <div class="flex md6">{{ decomptePages.text }}</div>
                    <div class="flex md2">{{ decomptePages.total }}</div>
                    <div class="flex md4">Total: {{ montants.total }} €</div>
                    <div class="flex md4">Remise: {{ montants.remise }} €</div>
                    <div class="flex md4">
                      Total remisé: {{ montants.total - montants.remise }} €
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex md2">
              <div class="row row-inside">
                <div class="flex md12">
                  <va-button @click="closeModal" class="fullwidth" color="info"
                    >Annuler</va-button
                  >
                </div>
                <div
                  class="flex md12"
                  v-if="this.$store.getters.user.publication_modifications"
                >
                  <va-button @click="openEdit" class="fullwidth" color="info"
                    >Modifier le devis</va-button
                  >
                </div>
                <div class="flex md12">
                  <va-button
                    disabled
                    @click="sendDevis"
                    class="fullwidth"
                    color="info"
                    >Envoyer le devis</va-button
                  >
                </div>

                <div class="flex md12">
                  <va-button @click="printDevis" class="fullwidth" color="info"
                    >Imprimer le devis</va-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="row row-inside mt-4">
            <div class="flex md12">
              <h4>Engagements sur les numéros</h4>
            </div>
            <div class="flex md12">
              <div
                class="pub"
                v-for="publication in devis.listJournal"
                :style="{ backgroundColor: backgroundColor(publication) }"
              >
                <div class="number">
                  {{ publication.numero ? publication.numero : "Hors-Série" }}
                </div>
                <div class="date">
                  {{
                    moment(
                      publication.date_previsionnelle,
                      "YYYY-MM-DD"
                    ).format("DD-MM-YYYY")
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="row row-inside mt-4">
            <div class="flex md12">
              <h4>Annonces</h4>
            </div>
            <div class="flex md11">
              <div class="row row-inside">
                <div class="flex md1">Numéro</div>
                <div class="flex md1">Date prévisionnelle</div>
                <div class="flex md2">Nom</div>
                <div class="flex md1">Type</div>
                <div class="flex md1">Taille</div>
                <div class="flex md1">Montant</div>
                <div class="flex md1">Remises</div>
                <div class="flex md1">Total HT</div>
                <div class="flex md1">Facturation</div>
              </div>
            </div>
            <div
              class="flex md12 separated annonces"
              v-for="(annonce, index) in devis.listAnnonces"
            >
              <div class="row row-inside">
                <div class="flex md11">
                  <div class="row row-inside">
                    <div class="flex md1">
                      {{ annonce.numero ? annonce.numero : "Hors-Série" }}
                    </div>
                    <div class="flex md1">
                      {{ annonce.date_previsionnelle }}
                    </div>
                    <div class="flex md2">
                      {{ annonce.nom }}
                    </div>
                    <div class="flex md1">
                      {{ annonce.type }}
                    </div>
                    <div class="flex md1">{{ annonce.size }} Pages</div>
                    <div class="flex md1">{{ annonce.montant }} €</div>
                    <div class="flex md1">
                      <p>{{ annonce.remise }} %</p>
                      <p>
                        {{
                          annonce.remise_fixe ? annonce.remise_fixe + "€" : ""
                        }}
                      </p>
                    </div>
                    <div class="flex md1">
                      {{ montantTotal(annonce) }}
                      €
                    </div>
                    <div class="flex md1">
                      {{
                        annonce.idpartenaire_facturation ? "Autre" : "Standard"
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </va-modal>
    <va-modal
      class="modal"
      v-model="showWaiting"
      hideDefaultActions
      noEscDismiss
      noOutsideDismiss
    >
      <va-progress-circle indeterminate color="info" />
    </va-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { cloneDeep, find, isEqual, sortedUniq, sortBy } from "lodash";

export default {
  name: "devis-visualisation",
  props: ["value", "iddevis"],
  data() {
    return {
      showDevis: false,
      devis: null,
      moment: moment,
      showWaiting: false,
    };
  },
  created() {
    this.initDevis();
  },
  computed: {
    montants: function () {
      let total = 0;
      let remise = 0;

      for (let ijk = 0; ijk < this.devis.listAnnonces.length; ijk++) {
        total += this.devis.listAnnonces[ijk].montant
          ? this.devis.listAnnonces[ijk].montant
          : 0;
        remise += this.devis.listAnnonces[ijk].remise
          ? (this.devis.listAnnonces[ijk].remise *
              this.devis.listAnnonces[ijk].montant) /
            100
          : 0;
        remise += this.devis.listAnnonces[ijk].remise_fixe
          ? parseFloat(this.devis.listAnnonces[ijk].remise_fixe)
          : 0;
      }

      return { total: total.toFixed(2), remise: remise.toFixed(2) };
    },
    decomptePages: function () {
      let cptQuart = 0;
      let cptDemi = 0;
      let cptFull = 0;
      let total = 0;

      for (let ijk = 0; ijk < this.devis.listAnnonces.length; ijk++) {
        if (this.devis.listAnnonces[ijk].size === "1/4") {
          cptQuart += 1;
          total += 0.25;
        } else if (this.devis.listAnnonces[ijk].size === "1/2") {
          cptDemi += 1;
          total += 0.5;
        } else if (this.devis.listAnnonces[ijk].size === "1") {
          cptFull += 1;
          total += 1;
        }
      }

      return {
        text:
          +cptFull +
          " pages / " +
          cptDemi +
          " demis pages / " +
          cptQuart +
          " quarts de pages",
        total: total + " pages",
      };
    },
    decomptesNumeros: function () {
      let listeNumeros = [];
      for (let ijk = 0; ijk < this.devis.listAnnonces.length; ijk++) {
        listeNumeros.push(this.devis.listAnnonces[ijk].numero);
      }
      listeNumeros = sortedUniq(sortBy(listeNumeros));
      return listeNumeros.length;
    },
    contact_facture: function () {
      if (this.devis.contact_billing_name) {
        if (this.devis.contact_billing_fonction) {
          return (
            this.devis.contact_billing_name +
            " - " +
            this.devis.contact_billing_fonction
          );
        } else {
          return this.devis.contact_billing_name;
        }
      } else {
        return "Entreprise - Adresse principale";
      }
    },

    contact_devis: function () {
      if (this.devis.contact_devis_name) {
        if (this.devis.contact_devis_fonction) {
          return (
            this.devis.contact_devis_name +
            " - " +
            this.devis.contact_devis_fonction
          );
        } else {
          return this.devis.contact_devis_name;
        }
      } else {
        return "Entreprise - Adresse principale";
      }
    },
    title: function () {
      //todo information on the devis
      return "Devis";
    },
  },
  watch: {
    value() {
      // Parent property changed; update internal variables
      this.showDevis = this.value;

      if (this.showDevis) {
        this.getDevis();
      }
      //this.resetDevis();
    },
  },
  methods: {
    montantTotal(annonce) {
      let montant = annonce.montant;
      let remise = annonce.remise;
      let remise_fixe = annonce.remise_fixe
        ? parseFloat(annonce.remise_fixe)
        : 0;
      return (montant * (1 - remise / 100) - remise_fixe).toFixed(2);
    },
    async sendDevis() {},
    async printDevis() {
      try {
        this.showWaiting = true;
        let resTmp = await axios.get("/api/publications/print-devis", {
          params: { iddevis: this.iddevis },
        });

        let url = resTmp.data.pdfurl;
        let devis_id = resTmp.data.devis_id;
        let response = await axios.get(url, { responseType: "blob" });
        const blob = new Blob([response.data], {
          type: "application/pdf",
        });
        this.showWaiting = false;
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Devis_" + devis_id;
        link.click();
        URL.revokeObjectURL(link.href);
        this.launchEpicmaxToast("Devis édité");
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de l'édition du devis");
        this.showWaiting = false;
      }
    },
    backgroundColor(publication) {
      if (publication.isactif) {
        return "#4ae387";
      } else if (publication.date_cloture) {
        return "#ccc";
      } else {
        return "#4ab2e3";
      }
    },
    openEdit() {
      this.$emit("modify", this.iddevis);
    },
    initDevis() {
      this.devis = {
        nom: null,
        listJournal: [],
        listAnnonces: [],
      };
    },
    async getDevis() {
      try {
        let resTmp = await axios.get("/api/publications/devis", {
          params: { iddevis: this.iddevis },
        });

        this.devis = resTmp.data;
        console.log(this.devis);
      } catch (error) {
        console.log(error);
      }
    },
    closeModal() {
      this.$emit("close", false);
      this.$emit("input", false);
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.popover {
  z-index: 1500;
}
.force-width-medium {
  width: 30vw;
  height: 60vh;
  overflow: auto;
}
.forcewidth {
  width: 85vw;
  height: 75vh;
  overflow: auto;
}
.fullwidth {
  width: 90%;
}

.pub {
  float: left;
  text-align: center;
  padding: 0.5em;
  color: white;
  margin: 0.5em;
}

.pub:hover {
  cursor: pointer;
}

.separated {
  border-bottom: solid 1px #ccc;
}

.annonces {
  padding: 10px;
}
.annonces:hover {
  background-color: rgb(223, 223, 223);
}

.info-box {
  background-color: rgb(235, 233, 233);
  margin: 15px 15px 0 0;
  padding: 10px;
  border-radius: 5px;
}
.info-box-title {
  color: $vue-green;
}
.info-box-content {
}
</style>
